import styled from 'styled-components'
import { OutlineButton, SecondaryButton } from 'common/button'
import { Typography } from 'common/typography'
import { useCertificate } from 'querys/certificates'
import { AiFillLinkedin, AiOutlineDownload } from 'react-icons/ai'
import utcValues from 'utils/utc-values'
import useLocation from 'hooks/use-location'

const CertificateInfoStyled = styled.div`
  h1 {
    margin-block-end: 8px;
  }
  .actions {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-block-start: 24px;
  }
  @media(min-width: 1024px) {
    .actions {
      margin-block-start: 24px;
      flex-direction: row;
    }
  }
`

function CertificateInfo() {
  const { href: url } = useLocation()
  const {
    data: {
      uuid, course: { title }, certificate_pdf, certificate_png, created_at,
    },
  } = useCertificate()
  const date = utcValues(created_at)


  const linkedin_url = certificate_pdf ? `
    https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${title}&organizationId=69129289&issueYear=${date.getFullYear()}&expirationYear=${date.getFullYear() + 2}&=expirationMonth=${date.getMonth() + 1}&issueMonth=${date.getMonth() + 1}&certUrl=${url}&certId=${uuid}
  ` : ''

  return (
    <CertificateInfoStyled>
      <Typography small="headline6" large="headline4" as="h1">
        ¡Felicidades por tu logro!
      </Typography>
      <Typography>
        Este es el resultado del trabajo duro y dedicación que otorgaste al
        {' '}
        <b>{title}</b>
        {'.'}
        <br />
        Comparte tu certificado y continúa avanzando con tu camino profesional.
      </Typography>
      <div className="actions">
        <SecondaryButton
          as="a"
          target="_blank"
          rel="noopener noreferrer"
          href={linkedin_url}
          responsive
          fullWidth
          disabled={!certificate_pdf || !certificate_png}
        >
          <AiFillLinkedin size={24} />
          Agregar a LinkedIn
        </SecondaryButton>
        <OutlineButton
          as="a"
          target="_blank"
          rel="noopener noreferrer"
          href={certificate_pdf}
          download
          responsive
          fullWidth
          disabled={!certificate_pdf}
        >
          <AiOutlineDownload size={24} />
          Descargar como PDF
        </OutlineButton>
      </div>
    </CertificateInfoStyled>
  )
}

export default CertificateInfo
